import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiDataDup3 } from "../../../../redux/reducers/commonApiSlice";
import { subscriptionMember } from "../../../../data/ApiEndpoints";
import AllPlans from "./AllPlans";
import ConsumedPlanStatus from "./ConsumedPlanStatus";
import { fetchWorkoutMappingStatsData } from "../../../../redux/workout-reducers/workoutApis";
import Loader from "../../../ui/Loader";

const MembershipDetails = ({
  userInfoData,
  rowData,
  isOnlySubscription,
  activeTab,
}) => {
  const dispatch = useDispatch();
  const { loadingDup3, dataDup3 } = useSelector((state) => state.common);
  const { loading, workoutMappingStats } = useSelector(
    (state) => state.workoutApi
  );

  const { user_id, subscription_id } = rowData || {};

  const iniPTDatas = {
    allMembershipDetails: [],
    allFreeTrialDetails: [],
    allPTsessionsDetails: null,
    allPTSessionDetailArray: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  function getDetails(filters, endpoint) {
    dispatch(
      fetchApiDataDup3({
        method: "GET",
        endpoint: endpoint,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  function getWorkoutMappingStats(filters) {
    dispatch(
      fetchWorkoutMappingStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    const sendableFilters = {
      member_id: user_id || "",
    };

    if (sendableFilters.member_id) {
      getDetails(sendableFilters, subscriptionMember);
    }
  }, []);

  useEffect(() => {
    const sendableFilters = {
      subscription_id: subscription_id || "",
    };

    if (sendableFilters.subscription_id) {
      getWorkoutMappingStats(sendableFilters);
    }
  }, []);

  useEffect(() => {
    if (dataDup3?.status && dataDup3?.data?.length > 0) {
      const { data, free_trial } = dataDup3 || {};

      setAllDatas((prevs) => ({
        ...prevs,
        allMembershipDetails: data,
        allFreeTrialDetails: free_trial,
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allMembershipDetails: [],
        allFreeTrialDetails: [],
      }));
    }
  }, [dataDup3]);

  useEffect(() => {
    if (
      workoutMappingStats?.status &&
      workoutMappingStats?.session_details?.length > 0
    ) {
      const { data, session_details } = workoutMappingStats || {};

      setAllDatas((prevs) => ({
        ...prevs,
        allPTsessionsDetails: session_details[0],
        allPTSessionDetailArray: data,
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allPTsessionsDetails: null,
        allPTSessionDetailArray: [],
      }));
    }
  }, [workoutMappingStats]);

  return (
    <div
      className={`membership-details-container flexBetween ${
        activeTab === "membership" ? "member-profile-memberhip-history" : ""
      }`}
    >
      <div
        className={`membership-details plan-details ${
          isOnlySubscription ? "only-subs" : ""
        }`}
      >
        {loadingDup3 ? (
          <Loader />
        ) : (
          <AllPlans allPlanData={allDatas.allMembershipDetails} />
        )}
      </div>

      {!isOnlySubscription && (
        <div className="membership-details plan-status-in-detail">
          {loading ? <Loader /> : <ConsumedPlanStatus allDatas={allDatas} />}
        </div>
      )}
    </div>
  );
};

export default MembershipDetails;
